/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const dateFormat = "DD MMMM YYYY";
export const dateFormatWithHours = "DD MMMM YYYY HH:mm";
export const timeFormat = "HH:mm";
